<template>
  <modal :show.sync="localOpen" :show-close="false" headerClasses="p-0 m-0">
    <ModalHeader
      slot="header"
      :title="$t('knowledge.modals.contribution.main-title')"
      @close="closeModal"
    />

    <form @keyup.enter.prevent.stop @keydown.enter.prevent.stop>
      <ContributionEdition
        v-show="currentStep === 0"
        @update-message="updateMessage"
        class="contribution-modal__section"
      />

      <ContributionModalParameterSelector
        v-show="currentStep === 1"
        :default-knowledge="defaultKnowledge"
        @update-product-filters="updateProductFilters"
      />
    </form>

    <ContributionModalFooter
      :steps="steps"
      :current-step="currentStep"
      :step-count="stepCount"
      :is-message-invalid="
        $v.contribution.label.$invalid && $v.contribution.body.$invalid
      "
      :is-knowledge-invalid="$v.contribution.knowledge.$invalid"
      @close="closeModal"
      @go-to-previous-step="goToPreviousStep"
      @go-to-next-step="goToNextStep"
      @send-contribution="sendContribution"
    />
  </modal>
</template>

<script>
import FileUploadMixin from '@/mixins/KnowledgeMixin/FileUploadMixin';
import { required, minLength } from 'vuelidate/lib/validators';
import ModalHeader from '../CreateProductNotificationModal/ModalHeader';
import ContributionEdition from './ContributionEdition';
import ContributionModalParameterSelector from './ContributionModalParameterSelector';
import ContributionModalFooter from './ContributionModalFooter';
import parseAttachments from './parseAttachments';

export default {
  name: 'contribution-modal',
  mixins: [FileUploadMixin],
  components: {
    ModalHeader,
    ContributionEdition,
    ContributionModalParameterSelector,
    ContributionModalFooter,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    defaultKnowledge: {
      type: String,
      default: '',
    },
    defaultParameters: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isMessageInvalid() {
      return (
        this.$v.contribution.label.$invalid ||
        this.$v.contribution.body.$invalid
      );
    },
  },
  data() {
    return {
      localOpen: this.open,
      steps: [0, 1],
      stepCount: 2,
      currentStep: 0,
      contribution: {
        label: '',
        body: '',
        knowledge: this.defaultKnowledge,
        parameters: this.defaultParameters,
        attachments: [],
      },
      attachments: [],
      cases: {},
    };
  },
  validations: {
    contribution: {
      label: {
        required,
        minLength: minLength(1),
      },
      body: {
        required,
        minLength: minLength(1),
      },
      knowledge: {
        required,
      },
    },
  },
  methods: {
    closeModal() {
      this.localOpen = false;
      this.$emit('close');
    },
    goToPreviousStep() {
      this.currentStep -= 1;
    },
    goToNextStep() {
      this.currentStep += 1;
    },
    updateMessage({ label, body, attachments }) {
      this.contribution.label = label;
      this.contribution.body = body;
      this.attachments = attachments;
    },
    updateProductFilters(newKnowledge) {
      Object.assign(this.contribution, { knowledge: newKnowledge });
    },
    async sendContribution() {
      if (this.attachments.length) {
        await this.mxFileUpload(this.attachments, (error, response) => {
          if (error) {
            const { message } = error;
            alert(message);
          } else {
            const parsedAttachments = parseAttachments(response);
            this.contribution.body = `${this.contribution.body}${parsedAttachments}`;
          }
        });
      }
      this.$emit('send-contribution', this.contribution);
      this.localOpen = false;
    },
  },
  watch: {
    localOpen() {
      if (!this.localOpen) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss">
.overflow-modal {
  max-height: 80vh !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}
</style>

<style lang="scss" scoped>
.contribution-modal__section {
  height: 60vh;
  overflow: auto;
}
</style>
